module.exports = __webpack_public_path__ + "img/like-channel.422dbd81.png";